import React, { useState } from 'react'
import download from 'downloadjs'
import { IoMdDownload } from 'react-icons/io'

// Components
import { Button } from './Button'
import Table from './Table'
import { ReportCustomizer } from './modals/reports/report_customizer'

// Constants
import { getReport, getReportByPath } from '../_services/report.service'
import { useModal } from '../_reduxHooks/modal.hook'
import { useNotifications } from '../_reduxHooks/notifications.hook'
import { useUser } from '../_reduxHooks/user.hook'

export const DownloadReportsTable = ({ reports, pathProvided, business = null }) => {
  const [downloadingReport, setDownloadingReport] = useState(false)
  const { openModal, closeModal } = useModal()
  const { showNotification } = useNotifications()
  const { user } = useUser()

  const getCurrentDate = () => {
    let currentDate = new Date()
    return currentDate.getFullYear() + '-' + parseInt(currentDate.getMonth() + 1) + '-' + currentDate.getDate()
  }

  const downloadReport = (reportName = 'Generate Custom Report', isLedger, path, params) => {
    // Set as loading
    if (!params || !params.length) {
      setDownloadingReport(true)
    }

    const handleReportSuccess = (resp) => {
      // If no content
      if (resp.status === 204) {
        showNotification({
          type: `warning`,
          message: 'No data available to generate this report',
        })
        closeModal()
      } else {
        download(resp.data, `${reportName}_${getCurrentDate()}.csv`)
        closeModal()
      }
    }

    const handleReportFinally = () => {
      setDownloadingReport(false)
    }

    const handleDownloadReport = (
      downloadFn,
      setLoadingReport = () => {},
      setReportError = () => {},
      setErrorMessage = () => {}
    ) => {
      downloadFn
        .then(handleReportSuccess)
        .catch((e) => {
          setReportError(true)
          setErrorMessage(e)
        })
        .finally(() => {
          setLoadingReport(false)
          handleReportFinally()
        })
      return
    }

    if (pathProvided) {
      if (params.length && (!business || (business.id && params.filter((p) => p.name != 'business_id').length))) {
        if (business && user.user_type != 'lender') {
          openModal(
            ReportCustomizer,
            {
              params: params.filter((p) => p.name != 'business_id'),
              path,
              handleDownloadReport,
            },
            { modalTitle: reportName }
          )
        } else {
          openModal(ReportCustomizer, { params, path, handleDownloadReport }, { modalTitle: reportName })
        }
      } else {
        if (!params.length) {
          getReportByPath(path).then(handleReportSuccess).finally(handleReportFinally)
        } else {
          openModal(ReportCustomizer, { params, path, handleDownloadReport }, { modalTitle: reportName })
        }
      }
    } else {
      getReport(reportName, business, isLedger).then(handleReportSuccess).finally(handleReportFinally)
    }
  }

  if (!reports || !reports.length) {
    return null
  }

  reports = reports.sort((a, b) => a.name.localeCompare(b.name))

  return (
    <Table
      className="with-border"
      columns={[
        {
          accessor: 'name',
          headingText: 'Name',
        },
        {
          accessor: `type`,
          headingText: '',
          disableSortBy: true,
          Cell: (props) => (
            <div className={`align-left`}>
              <Button
                buttonType="button"
                className="compact icon-left"
                disabled={downloadingReport}
                onClick={() => {
                  pathProvided
                    ? downloadReport(
                        props.row.original.name,
                        props.row.original.isLedger,
                        props.row.original.path,
                        props.row.original.params
                      )
                    : downloadReport(props.value, props.row.original.isLedger)
                }}
              >
                <IoMdDownload className="download-icon" />
                Download
              </Button>
            </div>
          ),
        },
      ]}
      data={reports}
      showPagination={false}
    />
  )
}
